module.exports = __webpack_public_path__ + "img/sns-icon-line.ad252fd2.png";